<svg [ngClass]="'icon-simple-' + iconId + ' icon-sz-' + size + 's'" role="img" title="{{ title }}">
  <title title="">{{ title }}</title>
  <use [attr.xlink:href]="'assets/icons/icons-simple.svg#' + this.iconId"></use>
</svg>
